import HTTPResponseEntity  from '@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js';
import MessagesOptionsItem from '../Collections/MessagesOptionsItem.js';

export { MessagesOptionsHTTPMapping as default };

/**
* Identities HTTP Mapping
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesOptionsHTTPMapping {
  /**
   * Maps message options http results into an option entity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {MessagesOptionsItem} options  options item entity
   * @param {HTTPResponseEntity}  response http response entity
   *
   * @return {void}
   */
  map(options, response) {
    if (!response.results) {
        return;
    }

    options.image_replacement = response.results.image_replacement.value;
    options.request_mdn       = response.results.request_mdn.value === 'always' ? 1 : 0 ;
  }

  /**
   * Maps message options from an object
   *
   * @todo move this from here to it's own mapping class
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {MessagesOptionsItem} options  options item entity
   * @param {HTTPResponseEntity}  response http response entity
   *
   * @return {void}
   */
    mapFromObject(options, object) {
      options.image_replacement = object.image_replacement;
      options.request_mdn       = object.request_mdn === 'always' ? 1 : 0 ;
    }
}